// Built-ins
import React from "react";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";

// Modules / Functions
import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";

// Icons / Images
import { FaInfo } from "react-icons/fa";
import { GoLaw } from "react-icons/go";

// Global Variables
import { rootIconStyle, pageHeader } from "../../global_vars";

// url path = '/help'
class Help extends React.Component {
  // Help contains Documentations, About and Terms pages
  render() {
    return (
      <>
        <NavigationBar />
        <div className="rootContainer">
          {pageHeader("help")}
          <div className="contentContainer">
            <div className="contentBody">
              <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ maxWidth: 720, width: '100%' }}>
                  <Menu vertical className="dmRootMenu">
                    {/* <Menu.Item as={Link} to="/help/staff_dox">
                      <BsFillKeyFill style={rootIconStyle} /> Staff Documentation
                    </Menu.Item>
                    <Menu.Item as={Link} to="/help/dev_dox">
                      <FaCode style={rootIconStyle} /> Developer Documentation
                    </Menu.Item> */}
                    {/* <Menu.Item as={Link} to="/help/updates">
                      <MdUpdate style={rootIconStyle} /> Updates & Fixes
                    </Menu.Item> */}
                    <Menu.Item as={Link} to="/about">
                      <FaInfo style={rootIconStyle} /> About
                    </Menu.Item>
                    <Menu.Item as={Link} to="/terms">
                      <GoLaw style={rootIconStyle} /> Terms
                    </Menu.Item>
                  </Menu>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Help;
